import { alert } from "./alert";
import confirm from "./confirm";
import datetime from "./datetime";

export default {
	alert,
	confirm,
	datetime
}



// WEBPACK FOOTER //
// ./src/util/index.js